import React from "react";

import {
  CHART_GRANULARITY_DAILY,
  CHART_GRANULARITY_WEEKLY,
} from "./chartsHelpers";

/**
 * Daily / Weekly segment control for Overview metric charts.
 *
 * @param {Object} props
 * @param {"daily"|"weekly"} props.value - Active granularity.
 * @param {(value: "daily"|"weekly") => void} props.onChange - Selection handler.
 * @returns {JSX.Element}
 */
const ChartGranularityToggle = ({ value, onChange }) => {
  const options = [
    { value: CHART_GRANULARITY_DAILY, label: "Daily" },
    { value: CHART_GRANULARITY_WEEKLY, label: "Weekly" },
  ];

  return (
    <div
      className="inline-flex rounded-md border border-gray-200 bg-gray-100 p-0.5"
      role="group"
      aria-label="Chart time grouping"
    >
      {options.map((option) => {
        const isActive = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            aria-pressed={isActive}
            className={`rounded px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide transition ${
              isActive
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default ChartGranularityToggle;
